/* ============
 * Invoice Preview Page
 * ============
 *
 * Page where the user can view the account information
 */
import Vue from 'vue';
import moment from 'moment';
import mixin from '../../../mixins/mixin';
import invoiceService from '../../../services/invoice';
import store from './../../../store';

export default {
  data() {
    return {
      loading: false,
      lang: 'fr',
      booking: {
        price: 0,
        deposit: 0,
        cleaning: 0,
        price_extra: 0,
        rental: {},
        rental_id: 0,
        checking: null,
        checkout: null,
      },
      guest: {},
      rental: {},
      channels: {},
      rentals: {},
      invoices: {},
      invoiceSum: 0,
      invoiceSum2: 0,
      vatSum: 0,
      contract: '',
      oldContract: '',
      firstTime: true,
      selectedInvoiceId: '',
      invoice: {},
      editable: {
        invoice_name: false,
        invoice_zip_code: false,
        invoice_address: false,
        invoice_city: false,
        invoice_country: false,
        invoice_business_number: false,
        rental_name: false,
        rental_address: false,
        rental_zip_code: false,
        rental_city: false,
        rental_country: false,
        booking_date: false,
        booking_nbr_adults: false,
        booking_nbr_children: false,
        guest_address: false,
        guest_first_name: false,
        guest_last_name: false,
        guest_city: false,
        guest_country: false,
        guest_zip_code: false,
        siret: false,
        checking_checkout: false,
        facture: false,
        facture_number: false,
        booking_nbr_adults_label: false,
        booking_nbr_children_label: false,
        vendeur_label: false,
        acheteur_label: false,
        reserved_on: false,
        reserved_on_label_first: false,
        reserved_on_label_second: false,
        payment_choice_label: false,
        bank_card_label: false,
        footer_label: false,
        footer_bottom_text: false,
        total_label: false,
        invoiceSum: false,
        invoiceSum_tva: false,
        invoiceSum2: false,
        total_ht_label: false,
        total_ht_invoice_sum: false,
        reduction_label: false,
        reduction_value: false,
        total_ht_discount_label: false,
        total_ht_discount_value: false,
        vat_amount_label: false,
        vat_amount_value: false,
        total_price_label: false,
        total_price_value: false,
        other_payment_description: false,
        service_charge_payment_description: false,
        cleaning_payment_description: false,
        taxes_payment_description: false,
        other_payment_total_nt_col: false,
        service_charge_payment_total_nt_col: false,
        cleaning_payment_total_nt_col: false,
        taxes_payment_total_nt_col: false,
        other_payment_tax_col: false,
        service_charge_payment_tax_col: false,
        cleaning_payment_tax_col: false,
        taxes_payment_tax_col: false,
        other_payment_tax_value_col: false,
        service_charge_payment_tax_value_col: false,
        cleaning_payment_tax_value_col: false,
        taxes_payment_tax_value_col: false,
        other_payment_total_gross_col: false,
        service_charge_payment_total_gross_col: false,
        cleaning_payment_total_gross_col: false,
        taxes_payment_total_gross_col: false,
        nights_payment_description: false,
        nights_payment_total_nt_col: false,
        nights_payment_tax_col: false,
        nights_payment_tax_value_col: false,
        nights_payment_total_gross_col: false,
        owner_first_name: false,
        owner_last_name: false,
      },
      isEditable: false,
      api_url: '',
      fictivePayments: [],
    };
  },

  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
  },

  mixins: [mixin],

  async mounted() {
    this.loading = true;
    this.api_url = process.env.API_URL;

    if (this.$route.name == 'bookings.invoice.edit') {
      this.isEditable = true;
    } else {
      this.isEditable = false;
    }

    if (this.$route.params.permalink) {
      await this.getBookingByPermalink(this.$route.params.permalink);
      this.loading = false;
    }
    const lang = localStorage.getItem('lang');
    this.lang = lang;
    Vue.config.lang = lang;
    document.title = this.$t('page_title');
    store.dispatch('changeLang', lang);
  },

  methods: {
    async getBookingByPermalink(permalink) {
      invoiceService.getInvoice(this, permalink);
    },

    calculate_invoice_sum() {
      this.invoiceSum = 0;
      this.invoiceSum2 = 0;
      this.vatSum = 0;

      if (this.invoices) {
        this.invoices.forEach((invoice) => {
          invoice.originalAmount = ((invoice.amount * 100) / (100 + invoice.vat)).toFixed(2);
          invoice.vatAmount = (invoice.amount - parseFloat(invoice.originalAmount)).toFixed(2);
          if (invoice.invoice_payment) {
            const invoicePayment = invoice.invoice_payment;
            invoice.originalAmount = invoicePayment.total ? parseFloat(invoicePayment.total) : invoice.originalAmount;
            invoice.vatAmount = invoicePayment.tax_value ? parseFloat(invoicePayment.tax_value) : invoice.vatAmount;
          }
          this.invoiceSum += parseFloat(invoice.originalAmount);
          this.vatSum += parseFloat(invoice.vatAmount);
          this.invoiceSum2 += invoice.amount * invoice.quantity;
        });

        this.invoiceSum = parseFloat(this.invoiceSum).toFixed(2);
        this.vatSum = parseFloat(this.vatSum).toFixed(2);
        this.invoiceSum2 = parseFloat(this.invoiceSum2).toFixed(2);
      }
    },

    async createPDF() {
      const vm = this;
      await invoiceService.generatePdf(vm);
    },

    async autoSave(field, e, id = null, col) {
      if (this.editable[`edit${col}${id}`] != undefined) {
        this.editable[`edit${col}${id}`] = false;
      } else {
        this.editable[field] = !this.editable[field];
      }
      const data = {
        booking_id: this.booking.id,
        field,
        value: e.target.value,
      };

      if (id != null) {
        data.id = id;
        await invoiceService.updatePayment(this, data);
        await this.getBookingByPermalink(this.$route.params.permalink);
      } else {
        await invoiceService.update(data, this);
        await this.getBookingByPermalink(this.$route.params.permalink);
      }
    },

    enableEditing(field, id = null, col = null) {
      const vm = this;
      if (vm.isEditable) {
        if (col != null) {
          Vue.set(vm.editable, `edit${col}${id}`, true);
        } else {
          vm.editable[field] = !vm.editable[field];
        }
        vm.$nextTick(() => {
          if (vm.$refs[field].length !== undefined && vm.$refs[field].length > 1) {
            const focusCol = vm.$refs[field].filter(column => id === parseInt((column.id).slice(-3), 10))[0];
            focusCol.focus();
          } else if (vm.$refs[field][0] !== undefined) {
            vm.$refs[field][0].focus();
          } else {
            vm.$refs[field].focus();
          }
        });

        return true;
      }
      return false;
    },

    async resetInvoice() {
      const vm = this;
      const data = {
        booking_id: vm.booking.id,
      };
      await invoiceService.reset(data, vm);
      await invoiceService.resetPayments(vm);
      await vm.getBookingByPermalink(vm.$route.params.permalink);
    },

    changeDateFormat(date, format) {
      if (!date) {
        return 'N/A';
      }
      return moment(date, 'YYYY-MM-DD').locale(this.lang).format(format);
    },

    changeLang(lang) {
      const vm = this;
      vm.lang = lang;
      Vue.config.lang = lang;
      document.title = vm.$t('page_title');
      toastr.success(vm.$t('account.settings.language_changed'));
      store.dispatch('changeLang', vm.lang);
    },
  },

  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/bookings/invoice/invoice.js